document.addEventListener('DOMContentLoaded', () => {
  // ———————————————————————————————————
  // Sticky Sidebar
  // ———————————————————————————————————
  const header = document.getElementById('shopify-section-header');
  const sidebar = document.querySelector('.oven-edu-sidebar');
  if (header && sidebar) {
    const updateSidebarTop = () => {
      const hidden = header.classList.contains('shopify-section-header-hidden');
      const offset = hidden ? 30 : header.getBoundingClientRect().height + 30;
      sidebar.style.top = offset + 'px';
    };
    updateSidebarTop();
    new MutationObserver((muts) => {
      muts.forEach((m) => m.attributeName === 'class' && updateSidebarTop());
    }).observe(header, { attributes: true });
    window.addEventListener('resize', updateSidebarTop);
  }

  // ———————————————————————————————————
  // Slide Utilities
  // ———————————————————————————————————
  function slideDown(el, duration = 300) {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    const height = el.scrollHeight + 'px';
    el.style.height = '0';
    el.offsetHeight;
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = height;
    el.addEventListener('transitionend', function handler() {
      el.style.removeProperty('height');
      el.style.removeProperty('transition');
      el.removeEventListener('transitionend', handler);
    });
  }
  function slideUp(el, duration = 300) {
    el.style.height = el.scrollHeight + 'px';
    el.offsetHeight;
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = '0';
    el.addEventListener('transitionend', function handler() {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('transition');
      el.removeEventListener('transitionend', handler);
    });
  }

  // ———————————————————————————————————
  // Expander (Read More/Less)
  // ———————————————————————————————————
  document.querySelectorAll('.oven-edu-content-expander').forEach((expander) => {
    const container = expander.closest('.oven-edu-content');
    const expanded = container.querySelector('.edu-content-expanded');
    expanded.style.display = 'none';

    expander.addEventListener('click', (e) => {
      e.preventDefault();
      if (expander.classList.contains('expander-primed')) {
        slideDown(expanded, 500);
        expander.classList.replace('expander-primed', 'expander-triggered');
        expander.textContent = 'Read Less';
      } else {
        slideUp(expanded, 500);
        expander.classList.replace('expander-triggered', 'expander-primed');
        expander.textContent = 'Read More';
      }
    });
  });

  // ———————————————————————————————————
  // Content Slides Navigation
  // ———————————————————————————————————
  document.querySelectorAll('.oven-edu-content-slide-nav-item').forEach((item) => {
    item.addEventListener('click', () => {
      document.querySelector('.oven-edu-content-slide-nav-item.active')?.classList.remove('active');
      document.querySelector('.oven-edu-content-slide.active')?.classList.remove('active');
      item.classList.add('active');
      const slideId = item.id.replace('Trigger', 'Slide');
      document.getElementById(slideId)?.classList.add('active');
    });
  });

  // ———————————————————————————————————
  // FAQ Accordion
  // ———————————————————————————————————
  const plusSvg = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 8.8999H0.5V6.8999H6.5V0.899902H8.5V6.8999H14.5V8.8999H8.5V14.8999H6.5V8.8999Z" fill="#777777"/></svg>`;
  const minusSvg = `<svg width="15" height="3" viewBox="0 0 15 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 2.8999V0.899902H14.5V2.8999H0.5Z" fill="#777777"/></svg>`;
  document.querySelectorAll('.oven-edu-content-faqdrop h3').forEach((header) => {
    const answer = header.closest('.oven-edu-content-faqdrop').querySelector('.oven-edu-content-faqdrop-item');
    answer.style.display = 'none';
    header.addEventListener('click', () => {
      const isOpen = answer.style.display !== 'none';
      if (isOpen) {
        slideUp(answer);
        header.querySelector('svg').outerHTML = plusSvg;
      } else {
        slideDown(answer);
        header.querySelector('svg').outerHTML = minusSvg;
      }
    });
  });

  // ———————————————————————————————————
  // Split Content Tabs
  // ———————————————————————————————————
  document.querySelectorAll('[id^="splitTrigger"]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      document.querySelector('[id^="splitTrigger"].active')?.classList.remove('active');
      document.querySelector('[id^="splitSlide"].active')?.classList.remove('active');
      trigger.classList.add('active');
      const slideId = trigger.id.replace('Trigger', 'Slide');
      document.getElementById(slideId)?.classList.add('active');
    });
  });
});
